<template>
    <hr class="x-divider" :style="{'border-top-color': color}" />
</template>

<script>
export default {
    name: 'XDivider',

    props: {
        color: {}
    }
}
</script>

<style lang="scss" scoped>

.x-divider {
    border: none;
    border-top: 1px solid rgba(255, 255, 255, .2);
    border-left: 0;
    border-right: 0;
    border-bottom: 0;
    box-shadow: none;
}

</style>
